import { IGradeRiskCriteria, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const gradeRiskCriteriasAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_gradeRiskCriterias: builder.query<any, any>({
      query: (params) => {
        return {
          url: `/grade-risk-criteria/`,
          params,
        }
      },
      providesTags: ['grade-risk-criteria'],
      
    }),
    GET_gradeRiskCriteriaById: builder.query<IGradeRiskCriteria, number>({
      query: (id) => ({
        url: `/grade-risk-criteria/${id}/`,
      }),
      providesTags: ['grade-risk-criteria'],
    }),
    POST_gradeRiskCriteria: builder.mutation<IGradeRiskCriteria, IGradeRiskCriteria>({
      query: (body) => ({
        url: `/grade-risk-criteria/`,
        method: 'POST',
        body,
      }),
    }),
    PUT_gradeRiskCriteria: builder.mutation<IGradeRiskCriteria, { id: number; body: IGradeRiskCriteria }>({
      query: ({ id, body }) => ({
        url: `/grade-risk-criteria/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['grade-risk-criteria'],
    }),
    DELETE_gradeRiskCriteria: builder.mutation<IGradeRiskCriteria, number>({
      query: (id) => ({
        url: `/grade-risk-criteria/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['grade-risk-criteria'],
    }),
  }),
})

export const {
  useGET_gradeRiskCriteriasQuery,
  useGET_gradeRiskCriteriaByIdQuery,
  usePOST_gradeRiskCriteriaMutation,
  usePUT_gradeRiskCriteriaMutation,
  useDELETE_gradeRiskCriteriaMutation,
} = gradeRiskCriteriasAPI
